const UPDATED = "July 12, 2026";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-serif text-xl text-brand-forest">{title}</h2>
      <div className="mt-3 space-y-3 text-sm text-brand-ink/75 leading-relaxed">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
      <span className="label-eyebrow">Legal</span>
      <h1 className="mt-3 font-serif text-4xl md:text-5xl text-brand-forest leading-tight">
        Privacy Policy
      </h1>
      <p className="mt-3 text-sm text-brand-muted">Last updated: {UPDATED}</p>

      <div className="mt-6 bg-white border border-brand-line rounded-md p-6 md:p-8">
        <p className="text-sm text-brand-ink/75 leading-relaxed">
          This Privacy Policy explains how High Vibe Pinnacle Pictures ("we", "us") collects,
          uses, and protects personal information through the Build A Bank IBC Savings
          Calculator platform (the "Service"), in accordance with the Personal Information
          Protection and Electronic Documents Act (PIPEDA) and applicable Ontario law.
        </p>

        <Section title="1. Information we collect">
          <p>
            <strong>Prospects (public breakdown form):</strong> name, email address, phone
            number, business name, province, and the business figures you enter (vehicle
            counts, retained earnings, staff counts, notes) so a licensed advisor can prepare
            your personalized breakdown.
          </p>
          <p>
            <strong>Advisors (accounts):</strong> your Google account name, email address, and
            profile picture when you sign in with Google, plus the branding details you add to
            your profile (firm name, logo, contact details).
          </p>
          <p>
            <strong>Technical:</strong> a session cookie used solely to keep you signed in. We
            do not use advertising or cross-site tracking cookies.
          </p>
        </Section>

        <Section title="2. How we use your information">
          <p>
            Prospect submissions are used to generate your savings breakdown and are shared
            only with the advisor whose link you used (or the platform operator if no advisor
            link was used) so they can follow up with you. Advisor account data is used to
            operate your private workspace, brand your PDF reports, and calculate your
            per-lead billing.
          </p>
        </Section>

        <Section title="3. Sharing and third parties">
          <p>We never sell personal information. We share data only with service providers needed to run the Service:</p>
          <p>
            <strong>Stripe</strong> processes payments (we never store card numbers).{" "}
            <strong>Resend</strong> delivers email notifications. <strong>Google</strong>{" "}
            provides sign-in authentication. Each processes data under its own privacy policy.
          </p>
        </Section>

        <Section title="4. Data isolation and security">
          <p>
            Each advisor's leads, scenarios, and settings are stored in an isolated workspace
            enforced at the database level. Sessions use secure, HTTP-only cookies and expire
            after 7 days. Data is transmitted over encrypted (HTTPS) connections.
          </p>
        </Section>

        <Section title="5. Retention and your rights">
          <p>
            We retain information for as long as needed to provide the Service. You may
            request access to, correction of, or deletion of your personal information at any
            time. Prospects may also ask the advisor who contacted them to delete their lead
            record.
          </p>
        </Section>

        <Section title="6. Contact">
          <p>
            For privacy questions or requests, contact the platform operator, High Vibe
            Pinnacle Pictures, through the contact details published on this website.
          </p>
        </Section>
      </div>
    </main>
  );
}
